'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = require('redux');

var _order = require('../actions/order');

var DEFAULT_FILTER = {
    status: -1,
    date: [],
    keyword: ''
};
var filter = function filter() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_FILTER;
    var action = arguments[1];

    switch (action.type) {
        case _order.FILTER_ORDERS:
            return Object.assign({}, state, action.filter);
        default:
            return state;
    }
};

var INITIAL_STATE = {
    isFetching: false,
    didInvalidate: false,
    items: [],
    pagination: {}
};
var orders = function orders() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case _order.INVALIDATE_ORDERS:
            return _extends({}, state, {
                didInvalidate: true
            });
        case _order.REQUEST_ORDERS:
            return _extends({}, state, {
                isFetching: true,
                didInvalidate: false
            });
        case _order.RECEIVE_ORDERS:
            return _extends({}, state, {
                isFetching: false,
                didInvalidate: false,
                items: action.orders,
                pagination: action.pagination
            });
        case _order.FAILURE_ORDERS:
            return _extends({}, state, {
                isFetching: false,
                error: action.error
            });
        default:
            return state;
    }
};

var orderReducer = (0, _redux.combineReducers)({
    orders: orders,
    filter: filter
});

exports.default = orderReducer;


//////////////////
// WEBPACK FOOTER
// ./src/js/reducers/order.js
// module id = 602
// module chunks = 0